const PageLayout = ({ children }: { children: React.ReactNode }) => {
  return <div className="p-4 text-sm">{children}</div>;
};

export default PageLayout;
